import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplashPageComponent } from './splash-page/splash-page.component';
import { HeaderComponent } from './components/header/header.component';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ClientComponent } from './landing-page/client/client.component';
import { ConceptComponent } from './landing-page/concept/concept.component';
import { HeroHeaderComponent } from './landing-page/hero-header/hero-header.component';
import { OfferComponent } from './landing-page/offer/offer.component';
import { PricingComponent } from './landing-page/pricing/pricing.component';
import { StartNowComponent } from './landing-page/start-now/start-now.component';
import { WhyMobileWiseComponent } from './landing-page/why-mobile-wise/why-mobile-wise.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { FooterComponent } from './components/footer/footer.component';
import { MaterialModule } from '../material/material.module';
import { RouterModule, Routes } from '@angular/router';
import { SignUpComponent } from './sign-up/sign-up.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const routes: Routes = [
  { path: '', component:LandingPageComponent},
]

@NgModule({
  declarations: [
    SplashPageComponent,
    LandingPageComponent,
    HeaderComponent,
    FooterComponent,
    HeroHeaderComponent,
    ClientComponent,
    ConceptComponent,
    OfferComponent,
    PricingComponent,
    WhyMobileWiseComponent,
    StartNowComponent,
    SignUpComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    MaterialModule,
    NgbTooltipModule
  ],
  exports:[
    SplashPageComponent
  ]
})
export class SplashModule { }
